<template>
  <div class="container">
    <div class="content">
      <div class="anchor2">
        <div @click="show=!show" class="clickArea">{{$t('m.OnThisPage')}}<i class="el-icon-arrow-down"></i> </div>
        <div v-if="show">
          <p @click="activeted(1)" class="s1"><a :class="{active:flag==1}" href="#box1">创世纪文件</a></p>
          <p @click="activeted(2)" class="s1"><a :class="{active:flag==2}" href="#box2">什么是创世纪文件</a></p>
          <p @click="activeted(3)" class="s1"><a :class="{active:flag==3}" href="#box3">创世时间和 Chain_id</a></p>
          <p @click="activeted(4)" class="s1"><a :class="{active:flag==4}" href="#box4">共识参数</a></p>
          <p @click="activeted(5)" class="s1"><a :class="{active:flag==5}" href="#box5">应用状态</a></p>
          <!-- <p @click="activeted(6)" class="s1"><a :class="{active:flag==6}" href="#box6"></a></p> -->
          <!-- <div class="subAnchor">
            <p @click="activeted(21)" class="s2"><a :class="{active:flag==21}" href="#box21">test</a></p>
            <p @click="activeted(22)" class="s2"><a :class="{active:flag==22}" href="#box22">test</a></p>
            <p @click="activeted(23)" class="s2"><a :class="{active:flag==23}" href="#box23">test</a></p>
            <p @click="activeted(24)" class="s2"><a :class="{active:flag==24}" href="#box24">test</a></p>
            <p @click="activeted(25)" class="s2"><a :class="{active:flag==25}" href="#box25">test</a></p>
            <p @click="activeted(26)" class="s2"><a :class="{active:flag==26}" href="#box26">test</a></p>
            <p @click="activeted(27)" class="s2"><a :class="{active:flag==27}" href="#box27">test</a></p>
          </div> -->
        </div>
      </div>
      <div id="box1" class="p1">创世纪文件</div>
      <div class="p3">本文档解释了 FaxChain 测试网的创世文件的结构。它还解释了如何为自己的测试网构建创世文件<span>FaxChain</span> 。</div>
      <div class="p3">请注意，您可以通过运行以下命令为您自己的测试网生成默认创世文件：</div>
      <div class="p3">
        <div style="padding:15px 10px;word-break:break-all;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">exchaind init < moniker > --chain-id < chain-id ></div>
        </div>
      </div>
      <div class="p3">创世文件存储在 <span>~/.exchaind/config/genesis.toml</span> .</div>
      <div id="box2" class="p2">什么是创世纪文件</div>
      <div class="p3">创世文件是一个 JSON 文件，它定义了区块链的初始状态。它可以看作0是你的区块链的高度。位于 height 的第一个块1将引用创世文件作为其父级。</div>
      <div class="p3">创世文件中定义的状态包含所有必要的信息，如初始代币分配、创世时间、默认参数等。让我们分解这些信息。</div>
      <div id="box3" class="p2">创世时间和 Chain_id</div>
      <div class="p3"><span>genesis_time</span> 定义在 genesis 文件的顶部。它是一个 UTC 时间戳，它指定区块链何时启动。此时，创世验证者应该上线并开始参与共识过程。当超过 2/3 的创世验证者（由投票权加权）在线时，区块链启动。</div>
      <div class="p3">
        <div style="padding:15px 10px;word-break:break-all;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">"genesis_time": "2019-03-13T17:00:00.000000000Z",</div>
        </div>
      </div>
      <div class="p3">这 <span>chain_id</span> 是您的链的唯一标识符。它有助于区分使用相同版本软件的不同链。</div>
      <div class="p3">
        <div style="padding:15px 10px;word-break:break-all;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">"chain_id": "faxchain",</div>
        </div>
      </div>
      <div id="box4" class="p2">共识参数</div>
      <div class="p3">接下来，创世文件定义共识参数。共识参数重新组合所有与共识层相关的参数，Tendermint在FaxChain. 让我们看看这些参数：</div>
      <div class="p3">
        <ul style="padding-left:30px;word-break:break-all">
          <li><span>block</span></li>
          <div class="p3">
            <ul style="padding-left:30px;word-break:break-all">
              <li><span>max_bytes</span> ：每个块的最大字节数。</li>
              <li><span>max_gas</span> ：每个区块的气体限制。块中包含的每笔交易都会消耗一些气体。包含在一个块中的交易使用的总气体不能超过这个限制。</li>
            </ul>
          </div>
          <li><span>vidence</span></li>
          <div class="p3">
            <ul style="padding-left:30px;word-break:break-all">
              <li><span>max_age</span> ：证据是验证者在相同高度（和圆形）处签署了两个不同区块的证明。这是在状态机级别受到惩罚的明显恶意行为。max_age 定义了证据不再有效的最大块数。</li>
            </ul>
          </div>
          <li><span>validator</span></li>
          <div class="p3">
            <ul style="padding-left:30px;word-break:break-all">
              <li><span>pub_key_types</span> ：验证器接受的公钥类型（ed25519, , ...）。secp256k1目前只ed25519接受。</li>
            </ul>
          </div>
        </ul>
      </div>
      <div class="p3">
        <div style="padding:15px 10px;word-break:break-all;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">"consensus_params": {</div>
          <div style="padding:5px 0 5px 25px">"block_size": {</div>
          <div style="padding:5px 0 5px 40px">"max_bytes": "150000",</div>
          <div style="padding:5px 0 5px 40px">"max_gas": "1500000"</div>
          <div style="padding:5px 0 5px 25px">},</div>
          <div style="padding:5px 0 5px 25px">"evidence": {</div>
          <div style="padding:5px 0 5px 40px">"max_age": "1000000"</div>
          <div style="padding:5px 0 5px 25px">},</div>
          <div style="padding:5px 0 5px 25px">"validator": {</div>
          <div style="padding:5px 0 5px 40px">"pub_key_types": [</div>
          <div style="padding:5px 0 5px 60px">"ed25519"</div>
          <div style="padding:5px 0 5px 40px">]</div>
          <div style="padding:5px 0 5px 25px">}</div>
          <div style="padding:5px 0">},</div>
        </div>
      </div>
      <div id="box5" class="p2">应用状态</div>
      <div class="p3">应用程序状态定义了状态机的初始状态。</div>
      <div class="p4">创世账户</div>
      <div class="p3">在本节中，定义了令牌的初始分配。可以通过直接编辑 genesis 文件来手动添加帐户，但也可以使用以下命令：</div>
      <div class="p3">
        <div style="padding:15px 10px;word-break:break-all;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">// Example: exchaind add-genesis-account ex1fh9tpkqka29n0mj307cu5cvp5ts0p4dl3mkv7r 10000000fax</div>
          <div style="padding:5px 0"></div>
          <div style="padding:5px 0">exchaind add-genesis-account < account-address > < amount >< denom ></div>
        </div>
      </div>
      <div class="p3"><span>accounts</span> 此命令在该部分下的列表中创建一个项目 <span>app_state</span> 。</div>
      <div class="p3">
        <div style="padding:15px 10px;word-break:break-all;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0 5px 0">"accounts": [</div>
          <div style="padding:5px 0 5px 25px">{</div>
          <div style="padding:5px 0 5px 35px">"address": "ex1fh9tpkqka29n0mj307cu5cvp5ts0p4dl3mkv7r",</div>
          <div style="padding:5px 0 5px 35px">"coins": [</div>
          <div style="padding:5px 0 5px 45px">{</div>
          <div style="padding:5px 0 5px 65px">"denom": "FAX",</div>
          <div style="padding:5px 0 5px 65px">"amount": "10000000"</div>
          <div style="padding:5px 0 5px 45px">}</div>
          <div style="padding:5px 0 5px 35px">],</div>
          <div style="padding:5px 0 5px 35px">"sequence_number": "0",</div>
          <div style="padding:5px 0 5px 35px">"account_number": "0",</div>
          <div style="padding:5px 0 5px 35px">"original_vesting": [</div>
          <div style="padding:5px 0 5px 45px">{</div>
          <div style="padding:5px 0 5px 65px">"denom": "FAX",</div>
          <div style="padding:5px 0 5px 65px">"amount": "26306000000"</div>
          <div style="padding:5px 0 5px 45px">}</div>
          <div style="padding:5px 0 5px 35px">],</div>
          <div style="padding:5px 0 5px 35px">"delegated_free": null,</div>
          <div style="padding:5px 0 5px 35px">"delegated_vesting": null,</div>
          <div style="padding:5px 0 5px 35px">"start_time": "0",</div>
          <div style="padding:5px 0 5px 35px">"end_time": "10000"</div>
          <div style="padding:5px 0 5px 25px">}</div>
          <div style="padding:5px 0 5px 0">]</div>
        </div>
      </div>
      <div class="p4">创世交易</div>
      <div class="p3">默认情况下，创世文件不包含任何 <span>gentx</span> . <span>Agentx</span> 是在创世文件中创建验证器的交易。一旦超过 2/3 的作为有效接收者的验证者（按投票权加权）上 <span>gentx</span> 线后，该链就会启动 <span>genesis_time</span> 。</div>
      <div class="p3">Agentx可以手动添加到 genesis 文件中，也可以通过以下命令添加：</div>
      <div class="p3">
        <div style="padding:15px 10px;word-break:break-all;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">exchaind collect-gentxs</div>
        </div>
      </div>
      <div class="p3">此命令会将所有 <span>gentxs</span> 存储的内容添加 <span>~/.exchaind/config/gentx</span> 到创世文件中。</div>

      
    </div>
    
    <div class="wrapper">
    <div class="anchor1">
      <p @click="activeted(1)" class="s1"><a :class="{active:flag==1}" href="#box1">创世纪文件</a></p>
      <p @click="activeted(2)" class="s1"><a :class="{active:flag==2}" href="#box2">什么是创世纪文件</a></p>
      <p @click="activeted(3)" class="s1"><a :class="{active:flag==3}" href="#box3">创世时间和 Chain_id</a></p>
      <p @click="activeted(4)" class="s1"><a :class="{active:flag==4}" href="#box4">共识参数</a></p>
      <p @click="activeted(5)" class="s1"><a :class="{active:flag==5}" href="#box5">应用状态</a></p>
      <!-- <p @click="activeted(6)" class="s1"><a :class="{active:flag==6}" href="#box6"></a></p> -->
      <!-- <div class="subAnchor">
        <p @click="activeted(21)" class="s2"><a :class="{active:flag==21}" href="#box21">test</a></p>
        <p @click="activeted(22)" class="s2"><a :class="{active:flag==22}" href="#box22">test</a></p>
        <p @click="activeted(23)" class="s2"><a :class="{active:flag==23}" href="#box23">test</a></p>
        <p @click="activeted(24)" class="s2"><a :class="{active:flag==24}" href="#box24">test</a></p>
        <p @click="activeted(25)" class="s2"><a :class="{active:flag==25}" href="#box25">test</a></p>
        <p @click="activeted(26)" class="s2"><a :class="{active:flag==26}" href="#box26">test</a></p>
        <p @click="activeted(27)" class="s2"><a :class="{active:flag==27}" href="#box27">test</a></p>
      </div> -->
    </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'genesisFile',
  data() {
    return {
      flag: 1,
      show: false
    }
  },
  methods: {
    activeted(i) {
      console.log('i',i);
      this.flag = i
    }
  },
  mounted() {
    window.scroll(0, 0)
  }
}
</script>


<style lang="sass" scoped>
span
  padding: 2px 5px
  color: red
  border: 1px solid #ccc
  font-size: 12px
@media screen and (min-width:980px)
  .container
    display: flex
    .content
      width: 78%
      padding: 10px 6px
      .p1
        padding: 20px 0
        font-size: 50px
        font-weight: 700
        line-height: 60px
      .p2
        padding: 20px 0
        font-size: 35px
        font-weight: 700
        line-height: 40px
      .p4
        padding: 20px 0
        font-size: 26px
        font-weight: 700
        line-height: 30px
      .p3
        line-height: 25px
        padding-bottom: 15px
        word-break: break-all
    .anchor2
      display: none
    .wrapper
      width: 22%
    .anchor1
      position: sticky
      top: 0px
      right: 0px
      padding: 0 15px
      padding-right: 0
      // width: 18%
      color: #525860
      font-size: 14px
      border-left: 1px solid #DADDE1
      .active  
        color: #7549A9
      .subAnchor
        padding: 0 15px
      a
        color: #525860
      a:hover
        color: #7549A9
        font-size: 15px
      .s1
        margin: 10px 0
        line-height: 20px
        cursor: pointer
      .s2
        margin: 10px 0
        line-height: 20px
        cursor: pointer
        // word-break: break-all
@media screen and (max-width:980px)
  .container
    display: flex
    .content
      overflow: auto
      // width: 75%
      padding: 10px 6px
      .p1
        padding: 20px 0
        font-size: 50px
        font-weight: 700
        line-height: 60px
      .p2
        padding: 20px 0
        font-size: 35px
        font-weight: 700
        line-height: 40px
        padding-top: 60px
        margin-top: -60px
      .p4
        padding: 20px 0
        font-size: 26px
        font-weight: 700
        line-height: 30px
        padding-top: 60px
        margin-top: -60px
      .p3
        line-height: 25px
        padding-bottom: 15px
        word-break: break-all
    .anchor1
      display: none
    .anchor2
      background: #F2F2F2
      border-radius: 5px
      color: #000
      padding: 10px 15px
      padding-right: 0
      // width: 25%
      font-size: 16px
      .clickArea
        padding-right: 15px
        color: #000
        display: flex
        justify-content: space-between
      .active  
        color: #7549A9
      .subAnchor
        padding-left: 15px
      a
        color: #525860
      a:hover
        color: #7549A9
      .s1
        margin: 10px 0
        line-height: 20px
        cursor: pointer
      .s2
        margin: 10px 0
        line-height: 20px
        cursor: pointer
        // word-break: break-all
</style>